<template>
    <div name="login" class="wrapper">
        <agreement v-if="isAgreement"
            @close="closeAgreementPage"
            @completeSign="completeSign"
        />
        <div class="page" v-if="isLoading && !isAgreement" >
            <!-- <common-modal 
                :title="'시스템 점검중'"
                :message="'안녕하세요, 솔닥입니다.<br><br>더 안정적인 서비스 제공을 위해 아래 시간 동안 시스템 점검이 진행될 예정입니다.<br><br>점검 일시: 2026.10.19 월요일 오후 21:00 ~ 23:00<br><br>점검 시간 동안은 서비스 접속 및 이용이 어려울 수 있으며, 점검 완료 후 정상적으로 이용하실 수 있습니다.'"
                :buttonCount="0"
            />     -->
            <span class="text1">500만 당뇨인을 위한 <span class="text1-bold">디지털 맞춤 솔루션</span></span>
            <img class="concierge-logo-image" src="../assets/concierge_logo.png" />
            <div class="row" v-if="updateMessage === null">
                <span class="text2">간편 로그인으로 바로 시작해 보세요!</span>
                <div class="kakao-button" style="margin-top: 20px;" @click="login">
                    <img class="kakao-button-icon" src="../assets/kakao.png" />
                    카카오톡으로 시작하기
                </div>
                <span class="text3" @click="channeltalkOpen" style="margin-top: 16px; cursor: pointer;">고객센터에 문의하기</span>
            </div>
            <div class="row" v-else>
                <span class="text2">신규 기능을 배포하기 위해<br>서비스 이용이 제한됩니다.</span>
                <span style="font-weight: 800;">{{ updateMessage }}</span>
                <span class="text2">이용에 불편을 드려 죄송합니다.</span>
            </div>
           
        </div>
    </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';
import Agreement from '@/components/organisms/contract/Agreement';
import Constant from '@/constant';
import axios from 'axios';
import CommonModal from '@/components/modals/CommonModal';
export default {
    name: 'login',
    components: {Agreement, CommonModal},
    data: function()
    {
        return {
            isAgreement: false,
            isLoading: false,
            access_token: null,
            kakaoId: null,
            phoneNumber: null,
            returnUrl: "",
            code: "",
            isUpdate: false,
            updateMessage: null
        }
    },
    mounted: async function()
    {
        // isUpdate
        // this.updateMessage = '작업일시: 3월 12일 오후 9시 ~ 익일 새벽 2시까지';
        //
        this.returnUrl = this.$route.query.returnUrl;
        this.code = this.$route.query.code;

        ChannelIO('shutdown')
        if(this.$route.query.kakao)
        { 
            this.$store.dispatch(Constant.SIGNIN_KAKAO, {kakao_access_token: this.$route.query.kakao})
                .then((res) => {
              
                    this.access_token = res.token;      
                    this.phoneNumber = res.phone_number;
                    this.kakaoId = res.kakao_id;
       
                    if(!res.is_exist)
                    {   
                        // 가입이 필요한 유저
                        this.isAgreement = true;
                        this.isLoading = true;
                        this.returnUrl = this.$route.query.return_url;
                        if(this.returnUrl.indexOf('|') > -1)
                        {
                            const parts = this.returnUrl.split('|');
                            this.returnUrl = parts[0];
                            this.code = parts.slice(1).join('|');
                        }
                    }       
                    
                    else {
                        // 기존 유저
                        cookies.setLocalStorage("access_token", this.access_token);

                        this.returnUrl = this.$route.query.return_url;
                        if(this.returnUrl.indexOf('|') > -1)
                        {
                            const parts = this.returnUrl.split('|');
                            this.returnUrl = parts[0];
                            this.code = parts.slice(1).join('|');
                        }
                        this.afterLogin();
                    }
                })  
                .catch(() => {

                })
            
            
        }   
        else
        {
            this.access_token = cookies.getLocalStorage("access_token");
            if(this.access_token === null || this.access_token === undefined || this.access_token === '')
            {
                this.isLoading = true;
            }
            else
            {
                this.afterLogin();
            }
        }



    },
    methods: {
        channeltalkOpen: function()
        {
            window.open("https://solcon.channel.io/home", "_blank")
        },
        login: function()
        {
            const REST_API_KEY = process.env.KAKAO_REST_API_KEY;
            const REDIRECT_URI = process.env.KAKAO_REDIRECT_URI;
            let STATE = process.env.LOGIN_URI;
            if(this.returnUrl === '' || this.returnUrl === undefined || this.returnUrl === null)
            {
                STATE = STATE + `/?return_url=home`
            }
            else
            {
                if(this.returnUrl === 'invite' && this.code !== null && this.code !== undefined && this.code !== null)
                {
                    STATE = STATE + `/?return_url=${this.returnUrl}|${this.code}`
     
                }
                else{
                    STATE = STATE + `/?return_url=${this.returnUrl}`
                }
                
            }

            
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&prompt=login&state=${STATE}`;
        },
        completeSign: function(agreement_terms_condition_description, agreement_personal_info, agreement_marketing)
        {
            this.$store.dispatch(Constant.SIGNIN_AGREEMENT, {agreement_service: agreement_terms_condition_description, agreement_personal_info: agreement_personal_info, agreement_marketing: agreement_marketing, token: this.access_token})
                .then(() => {
                    // return url
                    cookies.setLocalStorage("access_token", this.access_token, 7);
                    // cookies.setCookie("kakao", this.kakaoId, 7);
                    // cookies.setCookie("phone_number", this.phoneNumber, 7);
                    this.afterLogin();
                })
                .catch((err) => {
                    this.access_token = null;
                })

            this.isAgreement = false;
        },
        afterLogin: function()
        {
            if(this.returnUrl !== null && this.returnUrl !== '' && this.returnUrl !== undefined)
            {
                
                if(this.returnUrl === 'invite' && this.code !== null && this.code !== undefined && this.code !== null)
                {   
                    this.$router.push({path: "/" + this.returnUrl + "?code=" + this.code})
                }
                else
                {
                    this.$router.push({path: "/" + this.returnUrl})
                }
            }
            else{
                this.$router.push({path: '/home'})
            }
        },
        closeAgreementPage: function()
        {
            this.access_token = null;
            this.isAgreement = false;
        }
    }

}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        height: 100vh; /* 화면 전체 높이 */
        background-image: url('../assets/login_background_image.jpg');
        background-size: cover; /* 이미지가 요소를 꽉 채우도록 설정 */
        background-position: center; /* 이미지가 중앙에 정렬되도록 설정 */
        background-repeat: no-repeat; /* 이미지가 반복되지 않도록 설정 */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 0 16px 30px 16px;
        box-sizing: border-box;
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
    }

    .text1 {
        width: 100%;
        color: #1D4A94;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        position: absolute;
        top: 14%;
        left: 50%;
        transform: translate(-50%, -14%);
    }
    .text1-bold {
        color: #1D4A94;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
    }
    .concierge-logo-image {
        position: absolute;
        top: calc(14% + 46px);
        left: 50%;
        transform: translate(-50%, -26%);
        width: 256px;
    }   

    .text2 {
        color: #1D4A94;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
    }
    .kakao-button {
        width: 100%;
        display: flex;
        height: 55px;
        border-radius: 6px;
        background: #FFE601;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        position: relative;
        cursor: pointer;
    }
    .kakao-button-icon {
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translate(0%, -50%);
        width: 24px;
    }
    .text3 {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        cursor: pointer;
    }
    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/Login.vue